module.exports = __webpack_public_path__ + "img/pending.02cd54db.svg";